<template>
  <div id="header-logo">
    <div class="logo">
      <img src="../../../../assets/images/blueCross/logo.png" alt="">
    </div>
    <div class="blue-cross">
      <p>蓝十医旅</p>
      <p>solgan</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderLogo",
  components: {}
};
</script>

<style lang="scss" scoped>
#header-logo {
  display: flex;
  align-items: center;
  .logo {
    width: 50px;
    height: 50px;
    img {
      width: 100%;
    }
  }
  .blue-cross {

  }
}
</style>
